/*eslint-disable no-unused-vars */
/*eslint-disable quotes */
import React from 'react';
import HttpHeader from './httpheader';

const CryptoJS = require('crypto-js');

const fillKey = (key) => {
  const filledKey = Buffer.alloc(128 / 8);
  const keys = Buffer.from(key);
  if (keys.length < filledKey.length) {
    filledKey.map((b, i) => (filledKey[i] = keys[i]));
  }
  return filledKey;
};

const encrypt = (word, stringify) => {
  const privatekey = HttpHeader.getEncryptionKey();
  //let privatekey = 'bcf1dd2c04b890688a1c8ed0b2d1ffdb';

  const key = CryptoJS.enc.Utf8.parse(privatekey); //16

  let encrypted = '';

  const data = stringify ? JSON.stringify(word) : word;

  const srcs = CryptoJS.enc.Utf8.parse(data);
  encrypted = CryptoJS.AES.encrypt(srcs, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });

  return encrypted.toString();
};

const apiEncrypt = (data, stringify = true) => {
  const privatekey = HttpHeader.getEncryptionKey();
  //let privatekey = 'bcf1dd2c04b890688a1c8ed0b2d1ffdb';

  const encryptedData = encrypt(data, stringify);
  console.log('encrypted Data -');
  console.log(encryptedData);
  return encryptedData;
};

export default apiEncrypt;
